/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import VerticalSplit from "../../../Basis/Components/VerticalSplit";
import { createBelegeRouterDefinitions } from "../../Belege/Routes/belegeRouterDefintions";
import AppRouterDefinition from "./../../../AppRouterDefinition";

// Views
const RessourcenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenView"));
const RessourcenNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenNavigationView"));
const RessourceView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourceView"));
const RessourceDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourceDetailsView"));
const KategorienView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategorienView"));
const KategorienNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategorienNavigationView"));
const KategorieView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategorieView"));
const KategorieDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategorieDetailsView"));
const KategoriePreiseView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreiseView"));
const KategoriePreisView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreisView"));
const KategoriePreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreiseNavigationView"));
const KategoriePreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreisDetailsView"));
const KategoriePreispositionenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreispositionenView"));
const KategoriePreispositionView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreispositionView"));
const KategoriePreispositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreispositionenNavigationView"));
const KategoriePreispositionDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriePreispositionDetailsView"));
const KategoriebilderView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriebilderView"));
const KategoriebildView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriebildView"));
const KategoriebilderNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriebilderNavigationView"));
const KategoriebildDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriebildDetailsView"));
const KategoriedateienView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriedateienView"));
const KategoriedateiView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriedateiView"));
const KategoriedateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriedateienNavigationView"));
const KategoriedateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategoriedateiDetailsView"));
const KategorieExternesHotelDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/KategorieExternesHotelDetailsView"));
const BelegungenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/BelegungenView"));
const BelegungenNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/BelegungenNavigationView"));
const BelegungView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/BelegungView"));
const BelegungDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/BelegungDetailsView"));
const RessourcenplanRedirectView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenplanRedirectView"));
const RessourcenplanView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenplanView"));
const RessourcenplanDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenplanDetailsView"));
const RessourcenplanEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenplanEinstellungenView"));
const RechnungsdatenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/RechnungsdatenView"));
const StornobedingungDefinitionZuteilungView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Belege/Views/StornobedingungDefinitionZuteilungView"));
const KategorieZusatzfelderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/KategorieZusatzfelderView"));
const RessourcenEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenEinstellungenView"));
const RessourcenEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Views/RessourcenEinstellungenDetailsView"));
const TeilnahmenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Teilnahmen/Views/TeilnahmenView"));
const RessourcenkategorieanzeigenView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Einstellungen/Views/RessourcenkategorieanzeigenView"));

// Breadcrumbs
const RessourcenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourcenBreadcrumb"));
const RessourceBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourceBreadcrumb"));
const KategorienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategorienBreadcrumb"));
const KategorieBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategorieBreadcrumb"));
const KategoriePreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriePreiseBreadcrumb"));
const KategoriePreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriePreisBreadcrumb"));
const KategoriePreispositionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriePreispositionenBreadcrumb"));
const KategoriePreispositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriePreispositionBreadcrumb"));
const KategoriebilderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriebilderBreadcrumb"));
const KategoriebildBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriebildBreadcrumb"));
const KategoriedateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriedateienBreadcrumb"));
const KategoriedateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategoriedateiBreadcrumb"));
const KategorieExternesHotelDetailsBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategorieExternesHotelDetailsBreadcrumb"));
const BelegungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/BelegungenBreadcrumb"));
const BelegungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/BelegungBreadcrumb"));
const RessourcenplanBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourcenplanBreadcrumb"));
const RessourcenplanDetailsBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourcenplanDetailsBreadcrumb"));
const RessourcenplanEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourcenplanEinstellungenBreadcrumb"));
const StornobedingungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/StornobedingungenBreadcrumb"));
const KategorieZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/KategorieZusatzfelderBreadcrumb"));
const RessourcenEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RessourcenEinstellungenBreadcrumb"));
const RechnungsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../Components/RechnungsdatenBreadcrumb"));
const TeilnahmenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Teilnahmen/Components/TeilnahmenBreadcrumb"));
const RessourcenkategorieanzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Einstellungen/Components/RessourcenkategorieanzeigenBreadcrumb"));

export function createBelegungenRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            exact: true,
            path: `${safePathPrefix}/belegungen`,
            parentPath: !!pathPrefix ? `${safePathPrefix}` : undefined,
            render: props => <BelegungenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <BelegungenBreadcrumb {...props} />,
            ],
        },
        {
            path: `${safePathPrefix}/belegung/:belegungId`,
            render: props => (
                <VerticalSplit
                    left={() => <BelegungenNavigationView {...props} />}
                    right={() => <BelegungView {...props} />}
                />
            ),
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <BelegungenBreadcrumb {...props} />,
                <BelegungBreadcrumb {...props} />,
            ],
        },
        {
            exact: true,
            path: `${safePathPrefix}/belegung/:belegungId`,
            parentPath: `${safePathPrefix}/belegung/:belegungId`,
            render: props => <BelegungDetailsView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <BelegungenBreadcrumb {...props} />,
                <BelegungBreadcrumb {...props} />,
            ],
        },
        {
            exact: true,
            path: `${safePathPrefix}/belegung/:belegungId/rechnungsdaten`,
            parentPath: `${safePathPrefix}/belegung/:belegungId`,
            render: props => <RechnungsdatenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <BelegungenBreadcrumb {...props} />,
                <BelegungBreadcrumb {...props} />,
                <RechnungsdatenBreadcrumb {...props} />,
            ],
        },
        {
            exact: true,
            path: `${safePathPrefix}/belegung/:belegungId/teilnahmen`,
            parentPath: `${safePathPrefix}/belegung/:belegungId`,
            render: props => <TeilnahmenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <BelegungenBreadcrumb {...props} />,
                <BelegungBreadcrumb {...props} />,
                <TeilnahmenBreadcrumb {...props} />,
            ],
        },
        ...createBelegeRouterDefinitions(`${safePathPrefix}/belegung/:belegungId`, props => [
            ...createPreBreadcrumbs(props),
            <BelegungenBreadcrumb {...props} />,
            <BelegungBreadcrumb {...props} />,
        ]),
    ];
}

export const ressourcenRouterDefintions: Array<AppRouterDefinition> = [
    ...createBelegungenRouterDefinitions(undefined, _ => []),
    {
        path: "/ressourcen",
        exact: true,
        render: props => <RessourcenView {...props} />,
        createBreadcrumbs: () => [
            <RessourcenBreadcrumb />
        ],
    },
    {
        path: `/ressource/:ressourceId`,
        render: props => (
            <VerticalSplit
                left={() => <RessourcenNavigationView {...props} />}
                right={() => <RessourceView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <RessourcenBreadcrumb {...props} />,
            <RessourceBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressource/:ressourceId`,
        parentPath: `/ressource/:ressourceId`,
        render: props => <RessourceDetailsView {...props} />,
        createBreadcrumbs: props => [
            <RessourcenBreadcrumb {...props} />,
            <RessourceBreadcrumb {...props} />,
        ],
    },
    ...createBelegungenRouterDefinitions(
        "/ressource/:ressourceId",
        props => [
            <RessourcenBreadcrumb {...props} />,
            <RessourceBreadcrumb {...props} />,
        ]),
    {
        path: "/ressourcenkategorien",
        exact: true,
        render: props => <KategorienView {...props} />,
        createBreadcrumbs: () => [
            <KategorienBreadcrumb />
        ],
    },
    {
        path: `/ressourcenkategorie/:kategorieId`,
        render: props => (
            <VerticalSplit
                left={() => <KategorienNavigationView {...props} />}
                right={() => <KategorieView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategorieDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/preise`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategoriePreiseView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
        ],
    },
    {
        path: `/ressourcenkategorie/:kategorieId/preis/:preisId`,
        render: props => (
            <VerticalSplit
                left={() => <KategoriePreiseNavigationView {...props} />}
                right={() => <KategoriePreisView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
            <KategoriePreisBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/preis/:preisId`,
        parentPath: `/ressourcenkategorie/:kategorieId/preis/:preisId`,
        render: props => <KategoriePreisDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
            <KategoriePreisBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/preis/:preisId/positionen`,
        parentPath: `/ressourcenkategorie/:kategorieId/preis/:preisId`,
        render: props => <KategoriePreispositionenView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
            <KategoriePreisBreadcrumb {...props} />,
            <KategoriePreispositionenBreadcrumb {...props} />,
        ],
    },
    {
        path: `/ressourcenkategorie/:kategorieId/preis/:preisId/position/:preispositionId`,
        render: props => (
            <VerticalSplit
                left={() => <KategoriePreispositionenNavigationView {...props} />}
                right={() => <KategoriePreispositionView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
            <KategoriePreisBreadcrumb {...props} />,
            <KategoriePreispositionenBreadcrumb {...props} />,
            <KategoriePreispositionBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/preis/:preisId/position/:preispositionId`,
        parentPath: `/ressourcenkategorie/:kategorieId/preis/:preisId/position/:preispositionId`,
        render: props => <KategoriePreispositionDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriePreiseBreadcrumb {...props} />,
            <KategoriePreisBreadcrumb {...props} />,
            <KategoriePreispositionenBreadcrumb {...props} />,
            <KategoriePreispositionBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/bilder`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategoriebilderView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriebilderBreadcrumb {...props} />,
        ],
    },
    {
        path: `/ressourcenkategorie/:kategorieId/bild/:bildId`,
        render: props => (
            <VerticalSplit
                left={() => <KategoriebilderNavigationView {...props} />}
                right={() => <KategoriebildView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriebilderBreadcrumb {...props} />,
            <KategoriebildBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/bild/:bildId`,
        parentPath: `/ressourcenkategorie/:kategorieId/bild/:bildId`,
        render: props => <KategoriebildDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriebilderBreadcrumb {...props} />,
            <KategoriebildBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/dateien`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategoriedateienView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriedateienBreadcrumb {...props} />,
        ],
    },
    {
        path: `/ressourcenkategorie/:kategorieId/datei/:kategoriedateiId`,
        render: props => (
            <VerticalSplit
                left={() => <KategoriedateienNavigationView {...props} />}
                right={() => <KategoriedateiView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriedateienBreadcrumb {...props} />,
            <KategoriedateiBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/datei/:kategoriedateiId`,
        parentPath: `/ressourcenkategorie/:kategorieId/datei/:kategoriedateiId`,
        render: props => <KategoriedateiDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategoriedateienBreadcrumb {...props} />,
            <KategoriedateiBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/ressourcenkategorie/:kategorieId/stornobedingungen",
        parentPath: "/ressourcenkategorie/:kategorieId",
        render: props => <StornobedingungDefinitionZuteilungView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <StornobedingungenBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        path: "/ressourcenkategorie/:kategorieId/portalansichten",
        parentPath: "/ressourcenkategorie/:kategorieId",
        render: props => <RessourcenkategorieanzeigenView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <RessourcenkategorieanzeigenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/zusatzfelder`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategorieZusatzfelderView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategorieZusatzfelderBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: `/ressourcenkategorie/:kategorieId/externeshotel`,
        parentPath: `/ressourcenkategorie/:kategorieId`,
        render: props => <KategorieExternesHotelDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KategorienBreadcrumb {...props} />,
            <KategorieBreadcrumb {...props} />,
            <KategorieExternesHotelDetailsBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: "/ressourcenplan",
        render: () => <RessourcenplanRedirectView />,
        createBreadcrumbs: () => [<RessourcenplanBreadcrumb />],
    },
    {
        path: "/ressourcenplan/:ressourcenplanId",
        render: props => <RessourcenplanView {...props} />,
        createBreadcrumbs: props => [<RessourcenplanBreadcrumb />, <RessourcenplanDetailsBreadcrumb {...props} />],
    },
    {
        exact: true,
        parentPath: "/ressourcenplan/:ressourcenplanId",
        path: "/ressourcenplan/:ressourcenplanId",
        render: props => <RessourcenplanDetailsView {...props} />,
        createBreadcrumbs: props => [<RessourcenplanBreadcrumb />, <RessourcenplanDetailsBreadcrumb {...props} />],
    },
    {
        exact: true,
        parentPath: "/ressourcenplan/:ressourcenplanId",
        path: "/ressourcenplan/:ressourcenplanId/einstellungen",
        render: props => <RessourcenplanEinstellungenView {...props} />,
        createBreadcrumbs: props => [<RessourcenplanBreadcrumb />, <RessourcenplanDetailsBreadcrumb {...props} />, <RessourcenplanEinstellungenBreadcrumb {...props} />],
    },
    {
        path: `/ressourceneinstellungen`,
        render: props => <RessourcenEinstellungenView {...props} />,
        createBreadcrumbs: props => [
            <RessourcenEinstellungenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `/ressourceneinstellungen`,
        parentPath: `/ressourceneinstellungen`,
        render: props => <RessourcenEinstellungenDetailsView {...props} />,
        createBreadcrumbs: props => [
            <RessourcenEinstellungenBreadcrumb {...props} />,
        ],
    },
];